class faqTabs extends HTMLElement{
    constructor(){
      super();
      console.log('testing right now')
      this.tab_headings = this.querySelectorAll('.search-col .category-item');
      this.tab_items = this.querySelectorAll('.content-col  .content-item');
      this.search_input = this.querySelector('.component-input');
      this.faq_items = this.querySelectorAll('.content-col .faq-item');

      this.seach_notify = this.querySelector('.search-notify');
      this.search_content = this.querySelector('.search-content');
      this.search_no_content = this.querySelector('.search-no-content');
      this.field = this.querySelector('.search-data-result');
      this.tab_headings.forEach(e=>{
        e.addEventListener('click',()=>{

          if(e.classList.contains('active'))
          { 
            return;
          }

          this.tab_headings.forEach(ele=>{
            ele.classList.remove('active');
          })

        //   this.tab_items.forEach(ele2=>{
        //     ele2.classList.remove('active')
        //   })


          e.classList.add('active');
          this.tab_items.forEach(ele3=>{
            
            if(ele3.dataset.handle == e.dataset.handle)
            {
              ele3.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            } 
          })

        })
      })

      const debounce = (func, delay) => {
        let debounceTimer
        return function () {
            const context = this
            const args = arguments
            clearTimeout(debounceTimer)
            debounceTimer = setTimeout(() => func.apply(context, args), delay)
        }
    }

    this.search_input.addEventListener('input', debounce((event) => {
        this.onChange(event);
    }, 300))        

    this.search_input.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.field.classList.remove('none');
    });
    document.querySelector('body').addEventListener('click',()=>{
        this.field.classList.add('none');
    })

    }

    keywordHighlight(text, term) {
        var pattern = new RegExp('(' + term + ')(?![^<]*>)', 'gi');
        text = text.replace(pattern, '<mark>$1</mark>');;
        return text;
    };

    onChange(event)
    {
        const key = event.target.value.trim().toLowerCase();

        this.faq_items.forEach(e=>{
            e.classList.remove('hidden');
            e.parentElement.previousElementSibling.classList.remove('no-hidden');
            e.parentElement.previousElementSibling.classList.remove('hidden');
        })

        //re Format
        this.faq_items.forEach(e=>{
            let question = e.querySelector('.faq-item-question')
            question.innerHTML = question.dataset.default;
            let answer = e.querySelector('.faq-item-answer')
            answer.innerHTML = e.querySelector('.content-default').innerHTML;
        })

        this.search_content.innerHTML='';
        if (!key.length) {
            this.seach_notify.classList.add('none');
            this.search_content.classList.add('none');
            this.search_no_content.classList.add('none');
            return;

        }   
        if (key.length < 2 ) {
            this.seach_notify.classList.remove('none');
            this.search_content.classList.add('none');
            this.search_no_content.classList.add('none');
            return;
        } 
        this.seach_notify.classList.add('none');
        let count = 0;

        this.faq_items.forEach(e=>{
            let question = e.querySelector('.faq-item-question')
            question.innerHTML = question.dataset.default;
            let answer = e.querySelector('.faq-item-answer')
            let topic = e.dataset.topic;

            if (question.innerHTML.toLowerCase().includes(key)) {
                 count++;
                console.log('test array')
                var newText = this.keywordHighlight(question.innerHTML, key);
                //var newText2 = this.keywordHighlight(answer.innerHTML, key);

                let new_li = `<li class="search-item" data-id="${e.dataset.id}" data-handle="${ e.dataset.topic }">
                                <div class="item-question">
                                    ${ newText }
                                </div>
                                <div class="item-topic">
                                    Category :   ${topic.replace("-", ' ')}
                                </div>
                            </li>`
                this.search_content.insertAdjacentHTML("beforeend", new_li);            
                this.search_content.classList.remove('none');
                this.search_no_content.classList.add('none');

                


                //console.log('newText' , newText )
                //console.log('newText2' , newText2 )
                question.innerHTML = newText;
                //answer.innerHTML = newText2;
                // var newText = this.keywordHighlight(card_title, key);
                // var newText = this.keywordHighlight(card_title, key);
                e.parentElement.previousElementSibling.classList.add('no-hidden');
            }
            else
            {
                e.classList.add('hidden');
                e.parentElement.previousElementSibling.classList.add('hidden');
            }

            //reEvent 
            
        })

        if(count == 0 )
        {
            this.search_content.classList.add('none');
            this.search_no_content.classList.remove('none');
        }     
        else
        {



            
            //has item => reEvent item
            let items = document.querySelectorAll('faq-tabs-component .search-content .search-item');
            items.forEach(e=>{
                e.addEventListener('click',()=>{

                    this.tab_headings.forEach(ele=>{
                        if(ele.dataset.handle == e.dataset.handle)
                        {
                            ele.click();
                        }
                    })
           
                    this.faq_items.forEach(ele=>{
                        if(ele.dataset.id == e.dataset.id && ele.dataset.topic == e.dataset.handle )
                        {
                            ele.classList.add('highlight');
                            const yOffset = -220; 
                            const y = ele.getBoundingClientRect().top + window.scrollY  + yOffset;
                            
                            console.log('y' , y )
                            window.scrollTo({top: y, behavior: 'smooth'});
                            //ele.scrollIntoView();
                            setTimeout(()=>{
                                ele.classList.remove('highlight');
                            },5000)
                          
                        }
                    })
                })
            })
        }
    }
  
  }
  customElements.define('faq-tabs-component', faqTabs);